const routes = {
  login: {
    root: "/login",
  },
  homePage: {
    homePage: "/homePage",
  },
  packageDetails: {
    packageDetails: "/packageDetails",
  },
  createPackageVersion: {
    createPackageVersion: "/createPackageVersion",
  },
  packages: {
    root: "/packages",
  },
  uploads: {
    root: "/uploads",
  },
  coupons: {
    list: "/coupons",
    create: "/coupons/create",
    edit: (id) => `/coupons/${id}/edit`,
    view: (id) => `/coupons/${id}`,
  },
};

export default routes;
